import { DeleteIcon } from '@sketchnote/icons';
import { MoreActionMenu } from '@sketchnote/shared-components';
import * as React from 'react';

export interface ColumnToolbarProps {
  onClick?: (e: any) => void | undefined;
  isDefaultSection?: boolean;
}

export const ColumnToolbar = ({ onClick, isDefaultSection }: ColumnToolbarProps) => {
  return (
    <MoreActionMenu
      usePortal
      onClickMenuItem={onClick}
      classNames={{
        menuWrap: 'rounded-lg shadow-sm',
      }}
      menuItems={[
        {
          label: (
            <div className="flex font-regular text-gray-999 text-sm ">
              <DeleteIcon wrapperClass="mt-4 text-gray-500" />
              &nbsp;&nbsp; Delete
            </div>
          ),
          value: 'delete',
          isActive: isDefaultSection,
        },
        {
          label: (
            <ColumnToolbarLabel
              color="bg-gray-100"
              borderColor="border-gray-300"
              labelColor="Default"
            />
          ),
          value: '#F6F7F9',
        },
        {
          label: (
            <ColumnToolbarLabel
              color="bg-primary-100"
              borderColor="border-blue-300"
              labelColor="Blue"
            />
          ),
          value: '#EEF1FC',
        },
        {
          label: (
            <ColumnToolbarLabel
              color="bg-green-100"
              borderColor="border-green-300"
              labelColor="Green"
            />
          ),
          value: '#DFF8E3',
        },
        {
          label: (
            <ColumnToolbarLabel color="bg-red-100" borderColor="border-red-600" labelColor="Red" />
          ),
          value: '#FEEFED',
        },
        {
          label: (
            <ColumnToolbarLabel
              color="bg-yellow-100"
              borderColor="border-yellow-300"
              labelColor="Yellow"
            />
          ),
          value: '#FFF7D6',
        },
        {
          label: (
            <ColumnToolbarLabel
              color="bg-pink-100"
              borderColor="border-pink-300"
              labelColor="Pink"
            />
          ),
          value: '#fff5f7',
        },
        {
          label: (
            <ColumnToolbarLabel
              color="bg-purple-100"
              borderColor="border-purple-300"
              labelColor="Purple"
            />
          ),
          value: '#faf5ff',
        },
        {
          label: (
            <ColumnToolbarLabel
              color="bg-orange-200"
              borderColor="border-orange-300"
              labelColor="Orange"
            />
          ),
          value: '#fffaf0',
        },
      ]}
    />
  );
};

export interface ColumnToolbarLabelProps {
  color?: string;
  borderColor?: string;
  labelColor?: string;
}

export const ColumnToolbarLabel = ({
  color,
  borderColor,
  labelColor,
}: ColumnToolbarLabelProps): JSX.Element => {
  return (
    <div className="flex font-regular text-gray-999 text-sm">
      <div className={`w-14 h-14 border rounded-full ${color} ${borderColor} mt-4`}></div>
      &nbsp;&nbsp; {labelColor}
    </div>
  );
};
